import React from 'react'
import InstagramIcon from '../../../assets/images/front/svg/instagram-white.svg'
import YouTubeIcon from '../../../assets/images/front/svg/youtube-white.svg'
import TikTokIcon from '../../../assets/images/front/svg/tiktok-white.svg'

const Contacts: React.FC = () => {
  return (
    <>
      <div className="container py-6 md:py-0 md:pt-12 px-4">
        <div className="grid grid-cols-10 gap-4">
          <div className="md:col-span-1 hidden md:block"></div>
          <div className="col-span-5 md:col-span-2">
            <a
              href="https://www.instagram.com/jirkazezulka/"
              target="_blank"
              className="group flex flex-col items-center justify-center text-xl"
            >
              <div className="block w-[92px] h-[92px] rounded-full bg-[#00A0E3] group-hover:bg-[#0183BA] flex items-center justify-center mb-3 transition-colors duration-300">
                <img src={InstagramIcon} alt="" />
              </div>

              <span className="text-[#0183BA]">@jirkazezulka</span>
            </a>
          </div>
          <div className="col-span-5 md:col-span-2">
            <a
              href="https://www.instagram.com/dohlavy_online/"
              target="_blank"
              className="group flex flex-col items-center justify-center text-xl"
            >
              <div className="block w-[92px] h-[92px] rounded-full bg-[#00A0E3] group-hover:bg-[#0183BA] flex items-center justify-center mb-3 transition-colors duration-300">
                <img src={InstagramIcon} alt="" />
              </div>

              <span className="text-[#0183BA]">@dohlavy_online</span>
            </a>
          </div>
          <div className="col-span-5 md:col-span-2">
            <a
              href="https://www.youtube.com/@Dohlavy_online"
              target="_blank"
              className="group flex flex-col items-center justify-center text-xl"
            >
              <div className="block w-[92px] h-[92px] rounded-full bg-[#00A0E3] group-hover:bg-[#0183BA] flex items-center justify-center mb-3 transition-colors duration-300">
                <img src={YouTubeIcon} alt="" />
              </div>

              <span className="text-[#0183BA]">@dohlavy_online</span>
            </a>
          </div>
          <div className="col-span-5 md:col-span-2">
            <a
              href="https://www.tiktok.com/@dohlavy_online"
              target="_blank"
              className="group flex flex-col items-center justify-center text-xl"
            >
              <div className="block w-[92px] h-[92px] rounded-full bg-[#00A0E3] group-hover:bg-[#0183BA] flex items-center justify-center mb-3 transition-colors duration-300">
                <img src={TikTokIcon} alt="" />
              </div>

              <span className="text-[#0183BA]">@dohlavy_online</span>
            </a>
          </div>
          <div className="md:col-span-1 hidden md:block"></div>
        </div>
      </div>
    </>
  )
}

export default Contacts
